/**
 * UserFirstName.tsx - User Name Display Component
 *
 * Simple component that displays user's first name or username with welcome message.
 */

import { useProfile } from "core";
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { ReactFC } from '../../types/chat.types';
import { Text } from "@chakra-ui/react";

export const UserFirstName: ReactFC<{ fontSize?: string; as?: React.ElementType }> = ({ fontSize = "2xl", as = "span" }) => {
    const { data: profile } = useProfile({
        // fallbackData: initial.profile,
    });
    const { i18n } = useTranslation();
    const isRTL = ['ar', 'ckb', 'ur'].includes(i18n.language);
    const fontFamily = isRTL
        ? "'Muna', 'KV-Text', sans-serif"
        : "'KV-Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

    return (
        <Text as={as} fontSize={fontSize} fontFamily={fontFamily} fontWeight="bold">
            {profile?.firstname ? (
                <>
                    {t("welcome")} {profile.firstname.charAt(0).toUpperCase() + profile.firstname.slice(1)}!
                </>
            ) : (
                <>
                    {t("welcome")} {profile?.username.charAt(0).toUpperCase() + profile?.username.slice(1)}!
                </>
            )}
        </Text>
    );
};
